<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("branch module settings") }}
      </h1>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("drive module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_drive"
            name="chk_integrate_drive"
            v-model="meta.integrate_drive"
          />
          <label for="chk_integrate_drive">{{ $t("integrate") }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive for photos')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_changed"
            ref="drive_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("outbox module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_outbox"
            name="chk_integrate_outbox"
            v-model="meta.integrate_outbox"
          />
          <label for="chk_integrate_outbox">{{ $t("integrate") }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('warning notice template')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/outbox/template/catalog"
            name_field="name"
            value_field="template_id"
            @selected="reception_template_changed"
            ref="reception_template_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('vacation request template')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/outbox/template/catalog"
            name_field="name"
            value_field="template_id"
            @selected="vacation_request_template_changed"
            ref="vacation_request_template_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('payroll notification template')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/outbox/template/catalog"
            name_field="name"
            value_field="template_id"
            @selected="payroll_template_changed"
            ref="payroll_template_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  post,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";

export default {
  name: "EsermanSettings",
  components: {
    GenericDropdown,
    GenericUploader,
  },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    save() {
      let v = this;
      let data = v.meta;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
    drive_changed(value) {
      this.meta.drive_id = value.drive_id;
    },
    reception_template_changed(value) {
      this.meta.reception_template_id = value.template_id;
    },
    vacation_request_template_changed(value) {
      this.meta.vacation_request_template_id = value.template_id;
    },
    payroll_template_changed(value) {
      this.meta.payroll_template_id = value.template_id;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) {
          v.meta = conf;
          if (conf.drive_id) v.$refs.drive_dropdown.set_value(conf.drive_id);

          if (conf.reception_template_id)
            v.$refs.reception_template_dropdown.set_value(
              conf.reception_template_id
            );

          if (conf.vacation_request_template_id)
            v.$refs.vacation_request_template_dropdown.set_value(
              conf.vacation_request_template_id
            );

          if (conf.payroll_template_id)
            v.$refs.payroll_template_dropdown.set_value(
              conf.payroll_template_id
            );
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
